import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import PropTypes from "prop-types";
import FollowerAllow from "./FollowerAllow";
import FollowerNotAllow from "./FollowerNotAllow";
import FollowerBlock from "./FollowerBlock";


class   MemberFollower   extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.props=props;
    }


    render() {
        let _el=null;
        switch (this.props.status){
            case 50:
                _el=<div className="network-item-footer py-3 d-flex text-center">
                        <div className="col-6 pl-3 pr-1">
                            <FollowerAllow id={this.props.idFriend} />
                        </div>
                        <div className="col-6 pr-3 pl-1">
                            <FollowerNotAllow id={this.props.idFriend} />
                        </div>
                    </div> ;
                break;
            case 55:
                _el=<div className="network-item-footer py-3 d-flex text-center">
                    <div className="col-6 pl-3 pr-1">
                        <span className="btn-outline-primary btn-sm btn-block">
                            پذیرش شده
                        </span>
                    </div>
                    <div className="col-6 pr-3 pl-1">
                        <FollowerNotAllow id={this.props.idFriend} />
                    </div>
                </div> ;
                break;
            case 60:
                _el=<div className="network-item-footer py-3 d-flex text-center">
                    <div className="col-4 pl-2 pr-1">
                        <span className="btn-outline-danger btn-sm btn-block px-0 font-8">
                            پذیرش نشده
                        </span>
                    </div>
                    <div className="col-4 pr-1 pl-1">
                        <FollowerAllow id={this.props.idFriend} />
                    </div>
                    <div className="col-4 pr-2 pl-1">
                        <FollowerBlock id={this.props.idFriend} />
                    </div>
                </div> ;
                break;
            case 65:
                _el=<div className="network-item-footer py-3 d-flex text-center">
                    <div className="col-6 pl-3 pr-1">
                        <span className="btn-outline-primary btn-sm btn-block">
                            غیر فعال شده
                        </span>
                    </div>
                    <div className="col-6 pr-3 pl-1">
                        <FollowerAllow id={this.props.idFriend} />
                    </div>
                </div> ;
                break;

        }
        return (<>
                {_el}
            </>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

MemberFollower.contextType = MCbrowser;

MemberFollower.propTypes = {
    memberId:PropTypes.string,
    status:PropTypes.number,
    idFriend:PropTypes.string,
};


export default MemberFollower;
